export class MultipleChoiceResponse {
    constructor (
        public multiple_choice_question_id : number, // the backend "MultipleChoiceQuestion" class
        public question_id : number, // the backend "Question" class
        public survey_id : number,
        public response : number[] // option_ids
    ){}
}